import React from 'react';
import { FileText, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
    return (
        <div className="min-h-screen bg-slate-50 font-sans text-slate-900">
            <div className="max-w-4xl mx-auto px-6 py-12">
                <Link to="/" className="inline-flex items-center text-slate-500 hover:text-purple-600 mb-8 transition-colors">
                    <ArrowLeft size={20} className="mr-2" /> Tillbaka till startsidan
                </Link>

                <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-8 md:p-12">
                    <div className="flex items-center mb-8">
                        <div className="p-3 bg-purple-100 rounded-xl mr-4">
                            <FileText className="w-8 h-8 text-purple-600" />
                        </div>
                        <h1 className="text-3xl md:text-4xl font-bold text-slate-900">Användarvillkor</h1>
                    </div>

                    <div className="prose prose-slate max-w-none">
                        <p className="lead text-lg text-slate-600 mb-8">
                            Dessa villkor gäller mellan dig som kund och Lumidiom AB (org.nr 559569-4737), som driver tjänsten Noctra. Genom att skapa ett konto eller använda tjänsten godkänner du dessa villkor.
                        </p>

                        <h3>1. Om tjänsten</h3>
                        <p>
                            Noctra tillhandahåller en tjänst för att hjälpa privatpersoner att identifiera och begära borttagning av personuppgifter från söktjänster, upplysningssajter och databaser på internet. Vi agerar som ditt ombud i dessa processer baserat på den fullmakt du ger oss i samband med registreringen.
                        </p>

                        <h3>2. Vem får använda tjänsten?</h3>
                        <ul>
                            <li>Du måste vara <strong>minst 18 år</strong> gammal.</li>
                            <li>Du måste vara <strong>folkbokförd i Sverige</strong>.</li>
                            <li>Du ansvarar för att all information du anger är korrekt och att du har rätt att begära borttagning för den person uppgifterna gäller (dig själv eller någon du har laglig fullmakt för).</li>
                            <li>Missbruk av tjänsten (t.ex. för att dölja uppgifter i syfte att undvika rättslig efterforskning) kan leda till omedelbar avstängning och polisanmälan.</li>
                        </ul>

                        <h3>3. Tjänster och priser</h3>
                        <p>Noctra erbjuder följande tjänster:</p>

                        <h4>3.1 Prenumerationsplaner</h4>
                        <ul>
                            <li><strong>Noctra Bas:</strong> Löpande skydd för 1 person. Debiteras månadsvis eller årsvis i förskott.</li>
                            <li><strong>Noctra Pro:</strong> Maximalt skydd för upp till 2 personer. Debiteras månadsvis eller årsvis i förskott. Inkluderar utökade funktioner som Dark Web-bevakning, AI-synlighetsanalys och veckovis säkerhetsnyhetsbrev.</li>
                        </ul>

                        <h4>3.2 Engångsrensning</h4>
                        <p>
                            En engångsavgift för borttagning av dina uppgifter från alla kända söktjänster. Inkluderar en rapport med bevis på genomförd borttagning. Ingen löpande prenumeration ingår.
                        </p>

                        <h4>3.3 Prisändringar</h4>
                        <p>
                            Vi förbehåller oss rätten att ändra priser. Prisändringar för prenumerationer träder i kraft vid nästa förnyelseperiod. Du meddelas minst 30 dagar i förväg via e-post.
                        </p>

                        <h3>4. Betalning</h3>
                        <p>
                            Betalning sker via vår betalningspartner Stripe. Vi accepterar Visa, Mastercard, Klarna och PayPal. Vi lagrar aldrig dina kortuppgifter — all betalningsinformation hanteras direkt av Stripe i enlighet med PCI DSS.
                        </p>

                        <h3>5. Ångerrätt (Distansavtalslagen)</h3>
                        <p>
                            Enligt lag (2005:59) om distansavtal har du som konsument <strong>14 dagars ångerrätt</strong> från den dag du ingick avtalet. Du kan ångra ditt köp utan att ange skäl.
                        </p>
                        <ul>
                            <li><strong>Prenumerationer:</strong> Om vi redan har påbörjat arbete med borttagning under ångerfristen (med ditt samtycke), har vi rätt att ta betalt för den del av tjänsten som redan utförts.</li>
                            <li><strong>Engångsrensning:</strong> Om arbetet redan har slutförts i sin helhet har du inte rätt till ånger, förutsatt att du samtyckt till att vi påbörjar arbetet under ångerfristen.</li>
                        </ul>
                        <p>
                            För att utöva din ångerrätt, kontakta oss på <a href="mailto:support@noctra.se" className="text-purple-600 hover:underline">support@noctra.se</a> eller använd vår chattsupport.
                        </p>

                        <h3>6. Uppsägning av prenumeration</h3>
                        <ul>
                            <li>Du kan när som helst säga upp din prenumeration via ditt konto eller genom att kontakta support.</li>
                            <li><strong>Månadsvis:</strong> Uppsägning träder i kraft vid nästa periodskifte. Du behåller tillgång till tjänsten fram till dess.</li>
                            <li><strong>Årsplan:</strong> Uppsägning träder i kraft vid periodens slut. Ingen delåterbetalning görs för kvarvarande period, såvida inte ångerrätten gäller.</li>
                        </ul>

                        <h3>7. Pengarna-tillbaka-garanti</h3>
                        <p>
                            Vi erbjuder en <strong>pengarna-tillbaka-garanti</strong>. Om vi inte lyckas identifiera några personuppgifter kopplade till dig inom 30 dagar från din första betalning, har du rätt till full återbetalning. Kontakta <a href="mailto:support@noctra.se" className="text-purple-600 hover:underline">support@noctra.se</a> för att nyttja garantin.
                        </p>

                        <h3>8. Fullmakt</h3>
                        <p>
                            Genom att registrera dig och tillhandahålla dina uppgifter ger du Noctra (Lumidiom AB) fullmakt att i ditt namn:
                        </p>
                        <ul>
                            <li>Kontakta söktjänster och upplysningsföretag för att begära radering av dina personuppgifter.</li>
                            <li>Kontrollera publika register avseende din folkbokföringsadress (Adresslarm-tjänsten).</li>
                            <li>Bevaka AI-tjänsters behandling av dina personuppgifter (AI Synlighet-tjänsten).</li>
                        </ul>
                        <p>
                            <strong>Du garanterar</strong> på heder och samvete att du är den person uppgifterna gäller, alternativt att du har laglig fullmakt att agera å dennes vägnar.
                        </p>

                        <h3>9. Ansvarsbegränsning</h3>
                        <p>
                            Noctra garanterar inte att alla uppgifter kan tas bort från alla källor, då detta beror på tredje parts policyer och gällande lagstiftning (t.ex. utgivningsbevis enligt tryckfrihetsförordningen). Vi arbetar aktivt för att maximera resultatet.
                        </p>
                        <p>
                            Noctra ansvarar inte för:
                        </p>
                        <ul>
                            <li>Skada som uppstår på grund av att tredje part vägrar ta bort uppgifter.</li>
                            <li>Tillfälliga avbrott i tjänsten (planerade eller oplanerade).</li>
                            <li>Uppgifter som återpubliceras av tredje part efter att borttagning genomförts.</li>
                        </ul>

                        <h3>10. Personuppgifter</h3>
                        <p>
                            Vi hanterar dina personuppgifter i enlighet med vår <Link to="/privacy" className="text-purple-600 hover:underline">Integritetspolicy</Link> och gällande dataskyddslagstiftning (GDPR). Vi rekommenderar att du läser integritetspolicyn noggrant.
                        </p>

                        <h3>11. Immateriella rättigheter</h3>
                        <p>
                            Allt innehåll på webbplatsen — inklusive design, logotyper, texter och programvara — tillhör Lumidiom AB och skyddas av upphovsrättslagen. Kopiering eller återanvändning utan skriftligt tillstånd är förbjuden.
                        </p>

                        <h3>12. Ändringar av villkoren</h3>
                        <p>
                            Vi förbehåller oss rätten att ändra dessa villkor. Vid väsentliga ändringar meddelar vi dig via e-post minst 30 dagar i förväg. Fortsatt användning av tjänsten efter ändringar innebär att du godkänner de nya villkoren.
                        </p>

                        <h3>13. Tillämplig lag och tvister</h3>
                        <p>
                            Dessa villkor lyder under <strong>svensk lag</strong>. Tvist som inte kan lösas genom ömsesidig förhandling ska i första hand hänskjutas till <strong>Allmänna reklamationsnämnden (ARN)</strong> och i andra hand avgöras av svensk allmän domstol.
                        </p>

                        <h3>14. Kontaktuppgifter</h3>
                        <div className="bg-slate-50 rounded-xl p-6 not-prose">
                            <p className="font-semibold text-slate-900 mb-2">Lumidiom AB</p>
                            <p className="text-sm text-slate-600">Org.nr: 559569-4737</p>
                            <p className="text-sm text-slate-600">E-post: <a href="mailto:support@noctra.se" className="text-purple-600 hover:underline">support@noctra.se</a></p>
                            <p className="text-sm text-slate-600">Webbplats: <a href="https://noctra.se" className="text-purple-600 hover:underline">noctra.se</a></p>
                        </div>

                        <div className="mt-12 pt-8 border-t border-slate-200 text-sm text-slate-500">
                            <p>Senast uppdaterad: 2026-02-26</p>
                            <p>Lumidiom AB (org.nr 559569-4737), driver tjänsten Noctra</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsOfService;
